import { CalendarClock } from "lucide-react";
import { fmtCountdown, fmtDate } from "@/lib/format";
import { useLang } from "@/context/LanguageContext";
import { InfoHint } from "@/components/InfoHint";

export function nextMeasurementText(device, t, lang) {
  if (!device?.is_active) return t("Apparaat uitgeschakeld", "Device disabled");
  if (!device?.online) return t("Beschikbaar zodra het apparaat online is", "Available when the device is online");
  if (device.process_state === "FAULT") return t("Wachten op herstel van de storing", "Waiting for fault recovery");
  if (device.process_state === "MEASURING" || device.process_state === "WARMUP") return t("De meting loopt nu", "Measurement in progress");
  if (device.process_state === "FILTERING") return t("Na de actieve filtercyclus", "After the active filtering cycle");
  if (!device.next_expected) return t("Planning wordt opgehaald", "Retrieving schedule");
  return `${fmtDate(device.next_expected, lang)} · ${fmtCountdown(device.next_expected, lang)}`;
}

export function NextMeasurement({ device, compact = false, className = "" }) {
  const { t, lang } = useLang();
  return (
    <div className={`flex items-start gap-2 ${className}`} data-testid="next-measurement">
      <CalendarClock className={`${compact ? "h-3.5 w-3.5" : "h-4 w-4"} mt-0.5 shrink-0 text-primary`} />
      <div className="min-w-0">
        <div className="flex items-center gap-1 text-[9px] font-bold uppercase tracking-wider text-muted-foreground">
          {t("Volgende meting", "Next measurement")}<InfoHint helpKey="next_measurement" />
        </div>
        <div className={`${compact ? "text-[11px]" : "text-sm"} mt-0.5 font-semibold leading-tight`}>{nextMeasurementText(device, t, lang)}</div>
      </div>
    </div>
  );
}
